import TripItemEuRailJourney from './trip-item-eurail-journey-component';
//import TripItemEuRailJourneyService from './trip-item-rail-group-service';

const MODULE_NAME = 'app.trip.item-eurail-journey';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemEuRailJourney.DIRECTIVE_NAME, TripItemEuRailJourney);
    //.service('tripItemRailGroupService', TripItemRailGroupService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-eurail-journey/trip-item-eurail-journey-module.js